import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var StarFillIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M23 9c-.1-.4-.4-.6-.8-.7l-6.4-.9-2.9-5.8c-.2-.4-.5-.6-.9-.6s-.7.2-.9.6L8.2 7.4l-6.3.9c-.4.1-.7.3-.9.7-.2.4 0 .8.3 1l4.6 4.4-1.1 6.4c-.1.4.1.8.4 1 .3.2.7.3 1.1.1l5.7-3 5.7 3c.2.1.3.1.5.1s.4-.1.6-.2c.3-.2.5-.6.4-1l-1.1-6.4 4.6-4.4c.3-.2.4-.6.3-1z"
                    })
                })
            })
        ]
    });
};
StarFillIcon.isCarinaIcon = true;
export default StarFillIcon;
